webpackJsonp([35783957827783],{

/***/ 299:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(17);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _colors2 = __webpack_require__(11);
	
	var _colors3 = _interopRequireDefault(_colors2);
	
	var _colors4 = __webpack_require__(56);
	
	var _colors = _interopRequireWildcard(_colors4);
	
	var _mapProps = __webpack_require__(7);
	
	var _mapProps2 = _interopRequireDefault(_mapProps);
	
	var _styleguide = __webpack_require__(14);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _styleguide.ContentRow,
	      null,
	      _react2.default.createElement(
	        _styleguide.Container,
	        { py: '3' },
	        _react2.default.createElement(
	          _styleguide.Flex,
	          { row: 'wrap' },
	          _react2.default.createElement(
	            CTAContainer,
	            { mb: '3' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              'Know what you\u2019re building.'
	            ),
	            _react2.default.createElement(
	              _styleguide.Title,
	              { weight: 'light', lines: 1.5 },
	              'Use natural language to design, define, and model your requirements'
	            )
	          ),
	          _react2.default.createElement(_styleguide.Fill, { scale: 2 }),
	          _react2.default.createElement(
	            Form,
	            null,
	            _react2.default.createElement(
	              Label,
	              null,
	              'Enter your email',
	              _react2.default.createElement(Email, null)
	            ),
	            _react2.default.createElement(_styleguide.Fill, { scale: 2 }),
	            _react2.default.createElement(
	              Button,
	              null,
	              'Subscribe'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _styleguide.ContentRow,
	      { color: _colors3.default.gray[1], background: _colors3.default.indigo[6] },
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Know your requirements'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Understanding what to build starts with good requirements \u2014 REQS makes it easy. '
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'REQS is a collaborative tool for ',
	        _react2.default.createElement(
	          'b',
	          null,
	          'Requirements Development and Analysis'
	        ),
	        '. Leveraging natural language analysis it provides a workflow with structure and intelligence.'
	      )
	    ),
	    _react2.default.createElement(
	      _styleguide.ContentRow,
	      null,
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Work your way down'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Translate your high-level requirements into low-level contraints. Each time you add a sub-requirement you add a new layer of detail constraining the possible designs and solutions.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'When you use sub-requirements with REQS you have traceability.'
	      )
	    ),
	    _react2.default.createElement(
	      _styleguide.ContentRow,
	      { color: _colors3.default.gray[2], background: _colors3.default.gray[9] },
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Drawn from industry standards'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'REQS employs ideas from architecture and object oriented analysis to provide a simple structured approach.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'And, by using semantic technologies, REQS has the capability to reason about your requirements and identify mistakes.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Taken together your work is easier, more complete, and more collaborative.'
	      )
	    )
	  );
	};
	
	var Form = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'pages__Form'
	})(['display:flex;align-items:center;padding-bottom:1.5rem;margin-bottom:1.5rem;box-shadow:0 .1875rem 0 #e6ebf1;']);
	var Label = /*#__PURE__*/_styledComponents2.default.label.withConfig({
	  displayName: 'pages__Label'
	})(['color:#6b7c93;font-weight:300;letter-spacing:0.025em;']);
	var Email = /*#__PURE__*/_styledComponents2.default.input.attrs({ type: 'text', placeholder: 'tom@jerry.com' }).withConfig({
	  displayName: 'pages__Email'
	})(['color:\'#424770\';font-size:1.5rem;line-height:2rem;letter-spacing:\'0.025em\';::placeholder{color:#aab7c4;}display:block;margin:.625rem 0 1.25rem 0;max-width:30rem;padding:.625rem .875rem;box-shadow:rgba(50,50,93,0.14902) 0 .0625rem .1875rem,rgba(0,0,0,0.0196078) 0 .0625rem 0;border-radius:.25rem;background:white;transition:all 150ms ease;&:hover{', ';box-shadow:rgba(50,50,93,0.109804) 0 .25rem .375rem,rgba(0,0,0,0.0784314) 0 .0625rem .1875rem;transition:all 150ms ease;}&:focus{', ';box-shadow:0 .4375rem .875rem rgba(50,50,93,0.1),0 .1875rem .375rem rgba(0,0,0,0.08);transition:all 150ms ease;}'], '' /* box-shadow:
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     rgba(50, 50, 93, 0.109804) 0 .125rem .0625rem,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     rgba(0, 0, 0, 0.0784314) 0 0 .0625rem
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     ; */, '' /* box-shadow:
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              rgba(50, 50, 93, 0.109804) 0 .25rem .375rem,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              rgba(0, 0, 0, 0.0784314) 0 .0625rem .1875rem
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              ; */);
	
	var Button = /*#__PURE__*/_styledComponents2.default.button.withConfig({
	  displayName: 'pages__Button'
	})(['white-space:nowrap;border:0;outline:0;display:inline-block;height:2.5rem;line-height:2.5rem;padding:0 .875rem;box-shadow:0 .25rem .375rem rgba(50,50,93,0.11),0 .0625rem .1875rem rgba(0,0,0,0.08);color:#fff;border-radius:.25rem;font-size:.9375rem;font-weight:600;text-transform:uppercase;letter-spacing:0.025em;background-color:', ';text-decoration:none;transition:all 150ms ease;margin-top:0.75rem;&:hover{color:#fff;cursor:pointer;background-color:#7795f8;transform:translateY(-.0625rem);box-shadow:0 .4375rem .875rem rgba(50,50,93,0.1),0 .1875rem .375rem rgba(0,0,0,0.08);}&:active{color:#fff;cursor:pointer;background-color:', ';transform:translateY(.0625rem);box-shadow:0 .1875rem .3125rem rgba(50,50,93,0.1),0 0 .0625rem rgba(0,0,0,0.08);}'], _colors3.default.indigo[6], _colors3.default.indigo[8]);
	
	var CTAContainer = /*#__PURE__*/(0, _styledComponents2.default)(_styleguide.Container).withConfig({
	  displayName: 'pages__CTAContainer'
	})(['max-width:30rem;margin-left:0;']);
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-4d83436748910c7f3038.js